<template>
  <div>
    <div v-if="!theme" class="text-center">
      <b-spinner></b-spinner>
    </div>
    <div v-else>
      <app-header :title="theme.name" :subtitle="'Theme #' + theme.id">
        <b-button v-router-link="{ name: 'theme-editor', query: { id: theme.id }}" variant="primary">
          <i class="fa fa-pencil-square-o" style="font-size:20px" /> Edit Theme
        </b-button>
      </app-header>
      <b-container>
        <b-nav tabs class="mb-3">
          <b-nav-item active>
            Profile
          </b-nav-item>
        </b-nav>
        <div>
          <div>
            <b-card-group columns>
              <b-card no-body>
                <b-card-header>
                  Image
                </b-card-header>
                <img :src="'https://cdn.gokaizen.com/' + theme.src" alt="" style="max-width:100%;">
              </b-card>
              <b-card no-body>
                <b-card-header>
                  Description
                </b-card-header>
                <b-table-simple>
                  <b-tr>
                    <b-td>Category</b-td>
                    <b-td v-router-link="{ name: 'mediacategory-detail', params: { id: theme.category_id }}" class="text-right">
                      {{ theme.category_name }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>Created</b-td>
                    <b-td class="text-right">
                      {{ theme.created | moment("YYYY-MM-DD") }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>Updated</b-td>
                    <b-td class="text-right">
                      {{ theme.updated | moment("YYYY-MM-DD") }}
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td>Tags</b-td>
                    <b-td class="text-right">
                      {{ theme.tags || 'No tags specified' }}
                    </b-td>
                  </b-tr>
                </b-table-simple>
              </b-card>
            </b-card-group>
          </div>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import $api from '@/services/api';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
  },

  data() {
    return {
      query: '',
      theme: null,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      const themeId = this.$route.params.id;

      $api.get(`/v1/internal/themes/${themeId}`).then((theme) => {
        this.theme = theme;
      });
    },
  },
};
</script>
